import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { AddSquare, ArrowDown2, Book, Paperclip2 } from "iconsax-react";
import { useState } from "react";
import DocumentDrawer from "../../components/library-drawers/document-drawer";
import LinkDrawer from "../../components/library-drawers/link-drawer";
import MassiveUpload from "./drawers/massive-upload-drawer";

const HeaderDropdown = () => {
  const [isMassiveUploadOpen, setIsMassiveUploadOpen] = useState(false);
  const [isNewLinkOpen, setIsNewLinkOpen] = useState(false);
  const [isDocumentDrawerOpen, setIsDocumentDrawerOpen] = useState(false);

  const items = [
    {
      icon: <Book size="20" />,
      title: "Nuevo documento",
      onClick: () => {
        setIsDocumentDrawerOpen(true);
      },
    },
    {
      icon: <Paperclip2 size="20" />,
      title: "Nuevo link",
      onClick: () => {
        setIsNewLinkOpen(true);
      },
    },
    // {
    //   icon: <BoxAdd size="20" />,
    //   title: "Subida masiva",
    //   onClick: () => {
    //     setIsMassiveUploadOpen(true);
    //   },
    // },
  ];

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button>
            <AddSquare size={18} />
            Nuevo recurso
            <ArrowDown2 size="18" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="p-0">
          {items.map((option, index) => (
            <DropdownMenuItem key={index} onClick={() => option.onClick()}>
              <span className="opacity-70">{option.icon}</span>
              {option.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <MassiveUpload
        isOpen={isMassiveUploadOpen}
        setIsOpen={setIsMassiveUploadOpen}
      />

      <LinkDrawer
        isOpen={isNewLinkOpen}
        onOpenChange={(isOpen) => setIsNewLinkOpen(isOpen)}
      />

      <DocumentDrawer
        isOpen={isDocumentDrawerOpen}
        onOpenChange={(isOpen) => setIsDocumentDrawerOpen(isOpen)}
      />
    </>
  );
};

export default HeaderDropdown;
